import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { DataTable } from "@/components/DataTable";
import { LoadingState, ErrorState } from "@/components/LoadingError";
import { apiFetch } from "@/utils/api";

export function TeamPage() {
  const [pending, setPending] = useState<Record<string, unknown>[]>([]);
  const [active, setActive] = useState<Record<string, unknown>[]>([]);
  const [inviteEmail, setInviteEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = async () => {
    const data = await apiFetch<{ pending: Record<string, unknown>[]; active: Record<string, unknown>[] }>(
      "/admin/users",
    );
    setPending(data.pending);
    setActive(data.active);
  };

  useEffect(() => {
    load()
      .catch((e) => setError(e instanceof Error ? e.message : "Failed"))
      .finally(() => setLoading(false));
  }, []);

  const invite = async () => {
    await apiFetch("/auth/invite", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: inviteEmail }),
    });
    setInviteEmail("");
    alert("Invite created (share invite link with token from API in dev)");
    await load();
  };

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={error} />;

  return (
    <div className="space-y-6">
      <PageHeader title="Team" subtitle="Manage users in your organization" />
      <div className="bg-white rounded-lg shadow p-4 flex gap-2 max-w-md">
        <input
          className="flex h-9 w-full rounded-md border px-3 text-sm"
          placeholder="Email to invite"
          value={inviteEmail}
          onChange={(e) => setInviteEmail(e.target.value)}
        />
        <button type="button" className="bg-[#1e3a4f] text-white px-4 rounded-md text-sm" onClick={invite}>
          Invite
        </button>
      </div>
      {pending.length > 0 && (
        <section>
          <h3 className="font-semibold mb-2">Pending</h3>
          <DataTable
            columns={[
              { key: "email", header: "Email", render: (u) => String(u.username) },
              { key: "role", header: "Role", render: (u) => String(u.role_label) },
            ]}
            rows={pending}
            rowKey={(u) => String(u.id)}
          />
        </section>
      )}
      <section>
        <h3 className="font-semibold mb-2">Active Members</h3>
        <DataTable
          columns={[
            { key: "email", header: "Email", render: (u) => String(u.username) },
            { key: "name", header: "Name", render: (u) => String(u.display_name) },
            { key: "role", header: "Role", render: (u) => String(u.role_label) },
          ]}
          rows={active}
          rowKey={(u) => String(u.id)}
        />
      </section>
      <p className="text-sm text-muted-foreground">
        <Link to="/admin/billing" className="underline">Billing</Link> — upgrade if you need more seats.
      </p>
    </div>
  );
}
